<template>
  <div class="heatmaps">
    <FilteringMain
      @return-selection="updateMainFilter"
      :showDatePicker="true"
      :hideTerms="true"
      :hideAddress="true"
    />
    <div class="modes">
      <el-row
        :span="20"
        :gutter="0"
        align="middle"
        type="flex"
        class="row-bg"
        justify="start"
      >
        <el-col :span="5">
          <!-- <el-dropdown @command="goto" style="width: 80%;">
            <el-button type="default" style="width: 100%;">
              {{ categoryTitle }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" @click="changeCategory()">
              <el-dropdown-item command="modes_of_travel_map"
                >School Commute Travel Modes</el-dropdown-item
              >
              <el-dropdown-item command="user_base_map"
                >User Base</el-dropdown-item
              >
              <el-dropdown-item command="parking_locations_map"
                >Parking Locations</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>-->
        </el-col>
        <el-col :span="19" style="height: 75px; text-align: left">
          <!-- <transition name="fade" mode="out-in"> -->
          <div v-if="colors.car">
            <MapCircleButton
              icon="fas fa-car-side"
              :selected="modesSelection.indexOf('CAR') > -1"
              type="CAR"
              color="#FFFFFF"
              :background="colors.car"
              @toggle="toggleMode"
            />
            <MapCircleButton
              v-if="simulated"
              icon="fas fa-taxi"
              :selected="modesSelection.indexOf('TAXI') > -1"
              type="TAXI"
              color="#FFFFFF"
              :background="colors.taxi"
              @toggle="toggleMode"
            />
            <MapCircleButton
              v-if="simulated"
              icon="fas fa-car-alt"
              :selected="modesSelection.indexOf('CARPOOL') > -1"
              type="CARPOOL"
              color="#FFFFFF"
              :background="colors.carpool"
              @toggle="toggleMode"
            />
            <MapCircleButton
              v-if="simulated"
              icon="fas fa-bus"
              :selected="modesSelection.indexOf('BUS') > -1"
              type="BUS"
              color="#FFFFFF"
              :background="colors.bus"
              @toggle="toggleMode"
            />
            <MapCircleButton
              v-if="simulated"
              icon="fas fa-bus-alt"
              :selected="modesSelection.indexOf('SCHOOL BUS') > -1"
              type="SCHOOL BUS"
              color="#FFFFFF"
              :background="colors['school bus']"
              @toggle="toggleMode"
            />
            <MapCircleButton
              icon="fas fa-subway"
              v-if="simulated"
              :selected="modesSelection.indexOf('TRAIN') > -1"
              type="TRAIN"
              color="#FFFFFF"
              :background="colors.train"
              @toggle="toggleMode"
            />

            <MapCircleButton
              icon="fas fa-walking"
              :selected="modesSelection.indexOf('WALKING') > -1"
              type="WALKING"
              color="#FFFFFF"
              :background="colors.walking"
              @toggle="toggleMode"
            />
            <MapCircleButton
              icon="fas fa-biking"
              :selected="modesSelection.indexOf('BICYCLING') > -1"
              type="BICYCLING"
              color="#FFFFFF"
              :background="colors.bicycling"
              @toggle="toggleMode"
            />
            <MapCircleButton
              icon="fas fa-cat"
              :selected="modesSelection.indexOf('UNKNOWN') > -1"
              type="UNKNOWN"
              color="#FFFFFF"
              :background="colors.unknown"
              @toggle="toggleMode"
            />
            <MapCircleButton
              icon="fas fa-mountain"
              :selected="modesSelection.indexOf('STILL') > -1"
              type="STILL"
              color="#FFFFFF"
              :background="colors.still"
              @toggle="toggleMode"
            />
            <div
              style="display: inline-block; vertical-align: top"
              v-if="accType === 'SUPERADMIN'"
            >
              <div>
                <div style="display: inline-block">
                  <el-input
                    type="text"
                    style="width: 110px"
                    v-model="student_id"
                    placeholder="Student_id"
                  ></el-input>
                </div>
                <div style="display: inline-block">
                  <el-input
                    type="text"
                    v-model="accuracy"
                    style="width: 110px"
                    placeholder="accuracy"
                  ></el-input>
                </div>
                <div style="display: inline-block">
                  <el-input
                    type="text"
                    v-model="user_id"
                    style="width: 110px"
                    placeholder="user_id"
                  ></el-input>
                </div>
                <el-button size="small" type="warning" @click="getTrackedData"
                  >UPDATE Heatmap</el-button
                >
              </div>
            </div>
          </div>
          <div key="2" style="line-height: 75px">
            Parents
            <span
              class="legendBubble"
              :style="{ background: userTypeColors.parent }"
            ></span>
            | Staff
            <span
              class="legendBubble"
              :style="{ background: userTypeColors.staff }"
            ></span>
          </div>
          <!-- </transition> -->
        </el-col>
      </el-row>
    </div>
    <div style="position: relative">
      <div id="panel">
        <el-switch
          v-model="simulated"
          active-text="Simulated"
          inactive-text="Tracked"
          class="switch"
        ></el-switch>
        <el-switch
          v-model="modeBg"
          active-text="Bg On"
          inactive-text="Bg Off"
          class="switch"
        ></el-switch>
        <el-switch
          v-model="modeNormal"
          active-text="Non-bg On"
          inactive-text="Non-bg Off"
          class="switch"
        ></el-switch>
        <!--<button class='btn btn-default' ng-click="vm.changeGradient()" uib-tooltip="Gradient" tooltip-placement='bottom' tooltip-append-to-body='true'><i class="fa fa-tint" aria-hidden="true"></i></button>-->
        <button
          class="btn btn-default"
          @click="changeRadius"
          uib-tooltip="Radius"
          tooltip-placement="bottom"
          tooltip-append-to-body="true"
        >
          <i class="fa fa-circle" aria-hidden="true"></i>
        </button>
        <!--<button class='btn btn-default' ng-click="vm.changeOpacity()" uib-tooltip="Opacity" tooltip-placement='bottom' tooltip-append-to-body='true'><i class="fa fa-eye-slash" aria-hidden="true"></i></button>-->
        <button
          class="btn btn-default"
          @click="heatmapMaxIntensity('up')"
          uib-tooltip="Weight"
          tooltip-placement="bottom"
          tooltip-append-to-body="true"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
        <button
          class="btn btn-default"
          @click="heatmapMaxIntensity('down')"
          uib-tooltip="Weight"
          tooltip-placement="bottom"
          tooltip-append-to-body="true"
        >
          <i class="fa fa-minus" aria-hidden="true"></i>
        </button>
      </div>
      <div
        id="map_canvas"
        :class="{ firstTime: firstTime }"
        style="height: 700px"
      ></div>
      <div
        v-if="firstTime"
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          width: 547px;
          height: 204px;
          margin-top: -102px;
          margin-left: -273px;
          border: 3px solid #cccccc;
          background: #f2f2f2;
          box-shadow: 4px 3px 13px #474747;
          padding: 50px;
        "
      >
        <span style="color: #3e3e3e">Choose mode(s)</span>
        <div class="period" style="margin-top: 10px"></div>
        <button
          class="magentaButton"
          type="button"
          @click="update"
          style="
            background: #f43e9f;
            float: right;
            border-color: #f43e9f;
            font-size: 1.4rem;
            padding: 15px;
            color: #ffffff;
            margin-left: 5px;
          "
        >
          <i class="fa fa-play-circle" aria-hidden="true"></i> Generate
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import FilteringMain from "@/components/FilteringMainv2.vue";
import MapCircleButton from "@/components/MapCircleButton.vue";
import ModesColors from "@/constants/travelModesColors";
import OutlineColors from "@/constants/outlineColors";
import UsersColors from "@/constants/usersColors";
import ApiService from "../services/ApiService";
import { Loader } from "google-maps";
// import { debounce } from "vue-debounce";
// declare let google;
export default Vue.extend({
  data() {
    return {
      // accType: "",
      school_addresses: [],
      trackingMarkers: [],
      pickerOptions: [],
      selection: "",
      dateRange: null,
      modesSelection: [
        "CAR",
        "TRAIN",
        "BUS",
        "WALKING",
        "BICYCLING",
        "CARPOOL",
        "TAXI",
        "SCHOOL BUS",
        "STILL",
        "UNKNOWN",
      ],
      categoryTitle: "",
      colors: {},
      userTypeColors: {},
      outlineColors: {},
      zoom: 10,
      radius: 20,
      loading: true,
      filterOptions: {},
      center: { lat: 51.5074, lng: 0.1278 },
      travelMarkers: [],
      markers: [],
      accColor: {
        0: "red",
        1: "green",
      },
      currentZoom: 11.5,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
      maxZoom: 13,
      student_id: null,
      user_id: null,
      accuracy: null,
      maxIntensity: 1,
      gradient: [
        "rgba(0, 255, 255, 0)",
        "rgba(0, 255, 255, 1)",
        "rgba(0, 191, 255, 1)",
        "rgba(0, 127, 255, 1)",
        "rgba(0, 63, 255, 1)",
        "rgba(0, 0, 255, 1)",
        "rgba(0, 0, 223, 1)",
        "rgba(0, 0, 191, 1)",
        "rgba(0, 0, 159, 1)",
        "rgba(0, 0, 127, 1)",
        "rgba(63, 0, 91, 1)",
        "rgba(127, 0, 63, 1)",
        "rgba(191, 0, 31, 1)",
        "rgba(255, 0, 0, 1)",
      ],
      schoolIcon: {},
      schoolMarkers: [],
      schoolMarkersCircle: [],
      schoolMarkersCircleOuter: [],
      homeCircles: [],
      homeCirclesOuter: [],
      schoolCircles: [],
      schoolCirclesOuter: [],
      geofCircles: [],
      geofCirclesOuter: [],
      simulated: false,
      firstTime: false,
      showTrackedData: true,
      map: null,
      heatmap: null,
      pointArray: null,
      heatmapOptions: {
        radius: 2,
      },
      modeNormal: true,
      modeBg: true,
      google: null,
    };
  },
  components: {
    FilteringMain,
    // LMarker,
    // LPopup,
    // LTooltip,
    MapCircleButton,
  },
  methods: {
    updateMainFilter(data) {
      this.filterOptions = data;
      this.getHomeGeofences();
      this.getUserGeofences();
      // this.getMarkers();
    },
    toggleMode(mode) {
      if (this.modesSelection.indexOf(mode) > -1) {
        const index = this.modesSelection.indexOf(mode);
        this.$delete(this.modesSelection, index);
        this.$forceUpdate();
      } else {
        this.modesSelection.push(mode);
      }
      this.getHomeGeofences();
    },
    changeTrackedDataState() {
      this.showTrackedData = !this.showTrackedData;
    },
    changeSimulatedState() {
      this.simulated = !this.simulated;
    },
    changeRadius() {
      if (this.heatmapOptions.radius <= 20) {
        this.heatmapOptions.radius += 4;
      } else {
        this.heatmapOptions.radius = 4;
      }
      this.heatmap.set("radius", this.heatmapOptions.radius);
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    getSchools() {
      ApiService.generalApi.getOrgsWithAddress().then((response) => {
        const allSchools = response.data;
        const addresses = [];
        allSchools.forEach((item) => {
          if (item.address) {
            item.address.forEach((address) => {
              addresses.push({
                lat: parseFloat(address.latitude),
                lng: parseFloat(address.longitude),
                school_id: item.id,
              });
            });
          }
        });
        this.setSchoolMarkers(addresses);
        this.school_addresses = addresses;
      });
    },
    getHomeGeofences() {
      const payload = this.getPayload();
      ApiService.generalApi.getMarkers(payload).then((resp) => {
        this.setHomeGeofences(resp.data);
      });
    },
    getUserGeofences() {
      const payload = this.getPayload();
      ApiService.generalApi.getUserGeofences(payload).then((resp) => {
        this.setUserGeofences(resp.data);
      });
    },
    changeGradient() {
      this.heatmap.set(
        "gradient",
        this.heatmap.get("gradient") ? null : this.gradient
      );
    },
    setSchoolMarkers(schoolPositions) {
      if (!schoolPositions) {
        for (const i in this.schoolMarkers) {
          this.schoolMarkers[i].setMap(null);
        }
        schoolPositions = this.school_addresses.filter(
          (i) => this.filterOptions.school_ids.indexOf(i.school_id) > -1
        );
      }
      if (schoolPositions) {
        for (const i in this.schoolCircles) {
          this.schoolCircles[i].setMap(null);
        }
        for (const i in this.schoolCirclesOuter) {
          this.schoolCirclesOuter[i].setMap(null);
        }
        for (let i = 0; i < schoolPositions.length; i++) {
          const marker = new this.google.maps.Marker({
            position: {
              lat: Number(schoolPositions[i].lat),
              lng: Number(schoolPositions[i].lng),
            },
            map: this.map,
            title: schoolPositions[i].name,
            icon: this.schoolIcon,
          });
          // const bigCircle = new this.google.maps.Circle({
          //   center: {
          //     lat: Number(schoolPositions[i].lat),
          //     lng: Number(schoolPositions[i].lng)
          //   },
          //   map: this.map,
          //   fillColor: "#00B0F0",
          //   strokeWeight: 0,
          //   fillOpacity: 0.1,
          //   radius: 250
          // });
          const circle = new this.google.maps.Circle({
            center: {
              lat: Number(schoolPositions[i].lat),
              lng: Number(schoolPositions[i].lng),
            },
            map: this.map,
            strokeWeight: 0,
            fillColor: "#00B0F0",
            fillOpacity: 0.25,
            radius: 200,
          });
          // this.schoolCirclesOuter.push(bigCircle);
          this.schoolCircles.push(circle);
          this.schoolMarkers.push(marker);
        }
      }
    },
    setHomeGeofences(markers) {
      for (const i in this.homeCircles) {
        this.homeCircles[i].setMap(null);
      }
      for (const i in this.homeCirclesOuter) {
        this.homeCirclesOuter[i].setMap(null);
      }
      this.homeCircles = [];
      this.homeCirclesOuter = [];
      if (markers && markers.journeys.length < 1000) {
        let single, position;
        for (let i = 0; i < markers.journeys.length; i++) {
          single = markers.journeys[i];
          position = single.latLng.split(",");
          // const bigCircle = new this.google.maps.Circle({
          //   center: {
          //     lat: Number(position[0]),
          //     lng: Number(position[1])
          //   },
          //   map: this.map,
          //   fillColor: "#fdce6d",
          //   strokeWeight: 0,
          //   fillOpacity: 0.25,
          //   radius: 250
          // });
          const cirlce = new this.google.maps.Circle({
            center: {
              lat: Number(position[0]),
              lng: Number(position[1]),
            },
            map: this.map,
            strokeWeight: 0,
            fillColor: "#a4e908",
            fillOpacity: 0.15,
            radius: 200,
          });

          // this.homeCirclesOuter.push(bigCircle);
          this.homeCircles.push(cirlce);
        }
      }
    },
    setUserGeofences(data) {
      for (const i in this.geofCircles) {
        this.geofCircles[i].setMap(null);
      }
      for (const i in this.geofCirclesOuter) {
        this.geofCirclesOuter[i].setMap(null);
      }
      this.geofCircles = [];
      this.geofCirclesOuter = [];
      if (data && data.length < 1000) {
        let single;
        for (let i = 0; i < data.length; i++) {
          single = data[i];
          // const bigCircle = new this.google.maps.Circle({
          //   center: {
          //     lat: Number(single.lat),
          //     lng: Number(single.long)
          //   },
          //   map: this.map,
          //   fillColor: "#f1b5f5",
          //   strokeWeight: 0,
          //   fillOpacity: 0.25,
          //   radius: 250
          // });
          const cirlce = new this.google.maps.Circle({
            center: {
              lat: Number(single.lat),
              lng: Number(single.long),
            },
            map: this.map,
            strokeWeight: 0,
            fillColor: "#a748cd",
            fillOpacity: 0.15,
            radius: 200,
          });

          // this.geofCirclesOuter.push(bigCircle);
          this.geofCircles.push(cirlce);
        }
      }
    },
    getTrackedData() {
      const payload = this.getPayload();
      if (this.simulated) {
        this.showSimulated();
        return;
      }
      this.pointArray.clear();
      this.getHomeGeofences();
      this.getUserGeofences();
      this.setSchoolMarkers();
      this.heatmapData = [];
      this.loading = true;
      ApiService.sadminApi
        .getHeatmapData(payload)
        .then((resp) => {
          this.loading = false;
          resp.data.forEach((element) => {
            this.pointArray.push({
              location: new this.google.maps.LatLng(element.lat, element.lng),
              weight: 1,
            });
          });
          this.setHeatmapData();
        })
        .catch(() => (this.loading = false));
    },
    test(param) {
      alert(param);
    },
    showSimulated() {
      // if (this.student_id) {
      //   ApiService.sadminApi.getStudentMarkers(this.student_id).then(resp => {
      //     this.pointArray.clear();
      //     resp.data.forEach(element => {
      //       this.pointArray.push({
      //         location: new this.google.maps.LatLng(element.lat, element.lng),
      //         weight: 1
      //       });
      //     });
      //     this.setHeatmapData();
      //   });
      // } else if (this.accuracy) {
      //   ApiService.sadminApi.getJourney(this.accuracy).then(resp => {
      //     this.pointArray.clear();
      //     resp.data.forEach(element => {
      //       this.pointArray.push({
      //         location: new this.google.maps.LatLng(element.lat, element.lng),
      //         weight: 1
      //       });
      //     });
      //     this.setHeatmapData();
      //   });
      if (this.simulated) {
        ApiService.sadminApi
          .getHeatmapSimulatedData(this.getPayload())
          .then((resp) => {
            this.pointArray.clear();
            resp.data.forEach((element) => {
              this.pointArray.push({
                location: new this.google.maps.LatLng(
                  element.latitude,
                  element.longitude
                ),
                weight: 1,
              });
            });
            this.setHeatmapData();
          });
      }
    },
    getPayload() {
      const payload = {
        ...this.filterOptions,
        travelModes: this.modesSelection,
      };
      if (this.accuracy) {
        payload.accuracy = this.accuracy;
      }
      if (this.student_id) {
        payload.student_id = this.student_id;
      }
      if (this.user_id) {
        payload.user_id = this.user_id;
      }
      if (!this.modeNormal || !this.modeBg) {
        payload.mode = this.modeNormal ? "normal" : "bg";
      }
      payload.journeyMarkers = [];
      return payload;
    },
    setHeatmapData() {
      this.heatmap.setMap(null);
      this.heatmap = new this.google.maps.visualization.HeatmapLayer({
        data: this.pointArray,
        maxIntensity: this.maxIntensity,
      });
      this.heatmap.set(
        "gradient",
        this.heatmap.get("gradient") ? null : this.gradient
      );
      this.heatmap.set("radius", this.heatmapOptions.radius);

      this.heatmap.setMap(this.map);
    },
    heatmapMaxIntensity(action) {
      if (action == "up") {
        this.maxIntensity *= 1.2;
      } else if (action == "down") {
        this.maxIntensity *= 0.8;
        if (this.maxIntensity < 1) this.maxIntensity = 1;
      }

      this.heatmap.set("maxIntensity", this.maxIntensity);
    },
    convertToLatLng(markers) {
      const returnMarkers = [];
      let temp;
      markers.forEach((element) => {
        temp = element.latLng.split(",");
        if (temp.length == 2) {
          if (element.type) {
            element.type = element.type.toLowerCase();
            if (
              element.type == "car" &&
              this.modesSelection.indexOf("CARPOOL") > -1 &&
              element.is_shared == 1
            ) {
              element.type = "carpool";
            }
          }

          element.location = {
            lat: parseFloat(temp[0]),
            lng: parseFloat(temp[1]),
          };
          returnMarkers.push(element);
        }
      });
      // console.log("Markers HERE", returnMarkers);
      return returnMarkers;
    },
  },
  computed: {
    accType() {
      return this.$store.state.accType;
    },
    unread() {
      return this.$store.state.unread_messages;
    },
    // native() {
    //   return !this.$store.state.general.native;
    // }
  },
  async mounted() {
    this.colors = ModesColors;
    this.outlineColors = OutlineColors;
    this.userTypeColors = UsersColors;
    // this.accType = this.$store.state.user.admin_type.name;
    this.getSchools();
    const loader = new Loader("AIzaSyCN94noyQX1JyljLIwnaWs3K9NpVK4whDc", {
      libraries: ["visualization"],
    });
    const google = await loader.load();
    this.google = google;
    this.schoolIcon = {
      url: "https://s3-eu-west-1.amazonaws.com/home-run/other/school_pin.png", // url
      scaledSize: new google.maps.Size(30, 38),
    };
    const London = new google.maps.LatLng(51.507335, -0.127683);

    this.map = new google.maps.Map(document.getElementById("map_canvas"), {
      center: London,
      zoom: 8,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      streetViewControl: false,
      clickableIcons: false,
      fullscreenControl: true,
    });

    const myLatlng = { lat: -25.363, lng: 131.044 };
    // Create the initial InfoWindow.
    let infoWindow = new google.maps.InfoWindow({
      content: "Click the map to get Lat/Lng!",
      position: myLatlng,
    });
    // infoWindow.open(this.map);

    // Configure the click listener.
    this.map.addListener("click", (mapsMouseEvent) => {
      // Close the current InfoWindow.
      infoWindow.close();

      // Create a new InfoWindow.
      infoWindow = new google.maps.InfoWindow({
        position: mapsMouseEvent.latLng,
      });
      infoWindow.setContent(mapsMouseEvent.latLng.toString());
      infoWindow.open(this.map);
    });

    this.heatmap = new google.maps.visualization.HeatmapLayer({
      data: this.markers,
    });

    this.pointArray = new google.maps.MVCArray(this.markers);
    this.$forceUpdate();
  },
});
</script>
<style scoped>
.legendBubble {
  width: 14px;
  height: 14px;
  border-radius: 7px;
  background: red;
  display: inline-block;
  vertical-align: middle;
}
#panel {
  position: absolute;
  z-index: 999;
  margin-left: 300px;
  padding: 3px;
  background: rgba(255, 255, 255, 0.8);
}
</style>
<style>
.el-table .cell {
  word-break: normal !important;
}
div.heatmaps .circle {
  width: 50px;
  height: 50px;
}
div.heatmaps div.switch {
  margin-right: 20px;
}
</style>
